const copyGetter = (getter) => {
    return JSON.parse(JSON.stringify(getter));
}

export default copyGetter